import React from 'react';
import { Droplets, Zap, ShieldCheck } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 px-4 bg-emerald-900 text-white" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-emerald-100" data-id="element-64">
            El Problema Real: Su Páncreas está "Asfixiado"
          </h2>
          <div className="h-1 w-24 bg-emerald-500 mx-auto rounded-full" data-id="element-65"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-66">
          <div data-id="element-67">
            <p className="text-lg text-emerald-100 mb-6 leading-relaxed" data-id="element-68">
              El problema no es solo lo que come. El problema es que su páncreas
              está "asfixiado" por años de inflamación.
            </p>
            <p className="text-xl font-bold text-white mb-6 bg-emerald-800 p-4 rounded-lg border border-emerald-700" data-id="element-69">
              Imagine un filtro de auto que nunca se cambió... eso es su
              páncreas hoy.
            </p>
            <p className="text-lg text-emerald-100" data-id="element-70">
              Cuando el filtro está sucio, el motor falla. No importa qué
              combustible le ponga. Lo mismo pasa con su cuerpo: si no limpiamos
              el "filtro", la insulina no puede hacer su trabajo.
            </p>
          </div>
          <div className="bg-emerald-800 p-8 rounded-2xl border border-emerald-700 shadow-2xl" data-id="element-71">
            <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-72">
              El Protocolo de Limpieza Glicémica
            </h3>
            <ul className="space-y-4" data-id="element-73">
              <li className="flex items-start gap-3" data-id="element-74">
                <div className="bg-emerald-500 p-2 rounded-full" data-id="element-75">
                  <Droplets className="h-5 w-5 text-white" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <h4 className="font-bold" data-id="element-78">Detergente Natural</h4>
                  <p className="text-sm text-emerald-200" data-id="element-79">
                    7 hierbas ancestrales que limpian sus células beta.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-80">
                <div className="bg-emerald-500 p-2 rounded-full" data-id="element-81">
                  <Zap className="h-5 w-5 text-white" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h4 className="font-bold" data-id="element-84">Reseteo Metabólico</h4>
                  <p className="text-sm text-emerald-200" data-id="element-85">
                    Permite que la insulina vuelva a funcionar correctamente.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-86">
                <div className="bg-emerald-500 p-2 rounded-full" data-id="element-87">
                  <ShieldCheck className="h-5 w-5 text-white" data-id="element-88" />
                </div>
                <div data-id="element-89">
                  <h4 className="font-bold" data-id="element-90">Protección Duradera</h4>
                  <p className="text-sm text-emerald-200" data-id="element-91">
                    Mantiene los niveles estables sin dietas de hambre.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}